import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-egroup',
  templateUrl: './egroup.component.html',
  styleUrls: ['./egroup.component.sass']
})
export class EgroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
